import React from "react";
interface props {
  labelName: string;
  type: string;
  name:string;
  options: any;
  value: any;
  onChange: Function;
}
const ToggleButton = ({ labelName, type, name, options, value, onChange }: props) => {
  return (
    <div className="d-flex mb-2 align-items-center">
      <label className="label">{labelName}</label>
      {options?.map((item: any, index: number) => {
        return (
          <span key={index} className={`mx-2`}>
            <input
              key={item._id}
              type={type}
              name={name ? name : "level"}
              className="mx-2"
              checked={item._id === value}
              onChange={() => onChange(item._id)}
            />
            {item.name}
          </span>
        );
      })}
    </div>
  );
};
export default ToggleButton;
